__webpack_require__.p = "https://betatestingcentral.jdseller.com/mpstatic/digital-catalogue/";